import { ComboRow } from './coremodels';

export const simpleLabel = (x: ComboRow) => `${x.nam}`;

export const comboLabel = (x: ComboRow) => `${x.shc} - ${x.nam}`;

export const codeLabel = (x: ComboRow) => `${x.shc}`;

